module.exports = __webpack_public_path__ + "img/github.65c1f688.png";